<template>
  <div class="logout"></div>
</template>


<script>
import { LOGOUT } from "@/store/actions.type";

export default {
  beforeCreate() {
    this.$store.dispatch(LOGOUT)
      .then(() => {
        this.$router.replace({ name: 'login' })
      })
  }
};
</script>